import React from 'react';
import './Socialbar.css';
import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue} from "firebase/database";

const firebaseConfig = {
    apiKey: "AIzaSyBUiFO9anSm02yGQA5JnTe1-Y732hJ3Ing",
    authDomain: "personal-website-bb3dc.firebaseapp.com",
    databaseURL: "https://personal-website-bb3dc-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "personal-website-bb3dc",
    storageBucket: "personal-website-bb3dc.appspot.com",
    messagingSenderId: "351016613547",
    appId: "1:351016613547:web:685ffe991ea60eb27569ee"
  };

initializeApp(firebaseConfig);
const db = getDatabase();

class Socialbar extends React.Component
{
    constructor(props){
        super(props);
        this.state = {socials: []};
        const dbRef = ref(db, "Social");
        onValue(dbRef, (snapshot) => {
            const data = Object.values(snapshot.val());
            this.setState({socials: data})
        })
    }
    render()
    {
        return(
        <div className="social-bar">
            <div className="social-buttons">
                {this.state.socials.map(social =>
                    <a href={social.link}><i className={social.fa}></i></a>
                )}
            </div>
        </div>
        )
    }
}

export default Socialbar